import React from "react";
import { useTranslation } from "react-i18next";

const ChatFormDescription = () => {
  const { t } = useTranslation();

  return (
    <div>
      <div className="d-flex flex-row">
        <strong className="mb-3 fomm-information">{t("information1")}</strong>
      </div>
      <div className="mb-3">{t("information2")}</div>
    </div>
  );
};

export default ChatFormDescription;
